import React from 'react'

const LiveSessions = () => {
  return (
    <div>LiveSessions</div>
  )
}

export default LiveSessions